/* YSL cart drawer — matches staging minicart. Opens on cart-icon click + after
   add-to-cart (success header), AJAX qty/remove, "you may also like" recs via
   the Recommendations API. Refresh via Section Rendering API. Event-delegated;
   degrades to /cart links when JS off. */
(function () {
  'use strict';

  // Copy comes from window.yslI18n (rendered by snippets/ysl-i18n-js.liquid) because a
  // .js asset cannot run Liquid's `t` filter. The literal stays as the fallback, so a
  // missing key degrades to the Vietnamese copy instead of to an empty string.
  function T(k, fallback) { var d = window.yslI18n; return (d && d[k]) || fallback; }

  var SECTION_ID = 'ysl-cart-drawer';
  var RECS_SECTION = 'ysl-cart-drawer-recs';
  var ADDED_TITLE = T('cartAddedTitle', 'Đã thêm vào giỏ hàng');
  var PENDING_TITLE = T('cartAddingTitle', 'Đang thêm vào giỏ…');
  var recsFetchedFor = null;

  function root() { return document.querySelector('[data-cart-drawer]'); }
  function routesRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function open(opts) {
    var r = root();
    if (!r) return;
    opts = opts || {};
    /* Only one drawer at a time — tell the mobile mega-drawer to close (its cart
       link `.ysl-mdr__cart` lives inside it, so a tap opens this over the top). */
    document.dispatchEvent(new CustomEvent('ysl:cart-drawer-open'));
    r.classList.add('is-open');
    r.classList.toggle('is-success', !!opts.success);
    r.classList.toggle('is-pending', !!opts.pending);
    var title = r.querySelector('[data-cd-title]');
    if (title) title.textContent = opts.pending ? PENDING_TITLE : (opts.success ? ADDED_TITLE : (title.getAttribute('data-default-title') || title.textContent));
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    loadRecs();
    capAll();
    enforceCaps();
  }
  function close() {
    var r = root();
    if (!r) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function isOpen() { var r = root(); return r && r.classList.contains('is-open'); }

  /* On the cart PAGE the drawer is redundant — the page already is the cart, and
     sliding a second copy of it over the top just hides what the shopper came to
     look at. Adds still go through the Ajax path here (no reload); the page
     re-renders itself off cart:updated. The drawer is still rendered and kept in
     step so it's correct the moment they navigate away. */
  function onCartPage() { return !!document.querySelector('.ysl-cart[data-section-id]'); }
  function setLoading(on) { var r = root(); if (r) r.classList.toggle('ysl-cd--loading', !!on); }

  /* --- recommendations --- */
  function loadRecs() {
    var r = root();
    var box = r && r.querySelector('[data-cd-recs]');
    var row = box && box.querySelector('[data-cd-recs-row]');
    if (!box || !row) return;
    var pid = box.getAttribute('data-product-id');
    if (!pid || recsFetchedFor === pid) return;
    recsFetchedFor = pid;
    fetch(routesRoot() + 'recommendations/products?product_id=' + pid + '&limit=6&intent=related&section_id=' + RECS_SECTION, { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.ysl-cdr__card');
        if (!cards.length) { box.remove(); return; }
        row.innerHTML = '';
        cards.forEach(function (c) { row.appendChild(c); });
        box.classList.add('is-loaded');
        atcSyncAll();
      })
      .catch(function () {});
  }

  /* Swap drawer innards, preserve open + success state. */
  function render(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-drawer]');
    var cur = root();
    if (!next || !cur) return;
    var wasOpen = cur.classList.contains('is-open');
    var wasSuccess = cur.classList.contains('is-success');
    var prevTitle = cur.querySelector('[data-cd-title]');
    var titleText = prevTitle ? prevTitle.textContent : null;
    cur.replaceWith(next);
    /* Keep the header badge in step with EVERY drawer render — incl. gwp's
       background refresh after it auto-adds samples (which used to leave the
       badge stale, undercounting by the gift lines). Silent mirror: no
       cart:updated here, or gwp would re-run on its own render. */
    var rc = parseInt(next.getAttribute('data-cart-count'), 10);
    if (!isNaN(rc)) mirrorHeaderCount(rc);
    // empty cart is never a "success" state — drop the green-check header
    if (next.querySelector('.ysl-cd__empty')) wasSuccess = false;
    if (wasSuccess) {
      next.classList.add('is-success');
      var t = next.querySelector('[data-cd-title]');
      if (t && titleText) t.textContent = titleText;
    }
    /* Carry the recommendations across the swap. The server renders that row
       EMPTY — the Recommendations API fills it — so replacing the root blanks
       "Có thể bạn cũng thích" until a second fetch answers, a visible flash on
       every structural change (a gift arriving, a line removed). When the
       product it was fetched for hasn't changed, the cards are still valid:
       move them over and keep the fetched-for marker so no refetch happens. */
    var carried = false;
    var curBox = cur.querySelector('[data-cd-recs]');
    var nextBox = next.querySelector('[data-cd-recs]');
    if (curBox && nextBox && curBox.getAttribute('data-product-id') === nextBox.getAttribute('data-product-id')) {
      var curRow = curBox.querySelector('[data-cd-recs-row]');
      var nextRow = nextBox.querySelector('[data-cd-recs-row]');
      if (curRow && nextRow && curRow.children.length) {
        while (curRow.firstChild) nextRow.appendChild(curRow.firstChild);
        if (curBox.classList.contains('is-loaded')) nextBox.classList.add('is-loaded');
        carried = true;
      }
    }
    // product set may have changed → allow recs refetch, unless we carried them
    if (!carried) recsFetchedFor = null;
    armPad();
    capAll();
    enforceCaps();
    /* let ATC buttons re-check their variant against the new cart lines */
    document.dispatchEvent(new CustomEvent('ysl:cart-changed'));
    atcSyncAll();
    if (wasOpen) open({ success: wasSuccess });
  }

  /* Header badge = purchased units only, the same filter as ysl_real_count in
     sections/ysl-header.liquid. cart.item_count also counts the gifts that sit in
     the cart dormant and hidden, so the badge jumped after every edit until the
     next page load. */
  function realCount(cart) {
    if (!cart || !cart.items) return cart ? cart.item_count : 0;
    return cart.items.reduce(function (n, i) {
      var p = i.properties || {};
      return (p._gwp == null && p._giftwrap == null && p._sample == null && p._gift == null && p._tier_gift == null) ? n + i.quantity : n;
    }, 0);
  }

  /* Mirror the cart count into the header badge + "Giỏ hàng (n)" label. */
  function mirrorHeaderCount(count) {
    document.querySelectorAll('.ysl-head__cart-count').forEach(function (el) { el.textContent = count; });
    var label = document.querySelector('.ysl-head__cart .ysl-head__acct-label');
    if (label) label.textContent = label.textContent.replace(/\(\d+\)/, '(' + count + ')');
  }

  /* Mirror + announce (cart:updated drives ysl-gwp.js). */
  function updateHeader(count, rendered) {
    mirrorHeaderCount(count);
    /* rendered = this mutation already handed the cart page its HTML, so it
       must not go fetch a render of its own. */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count, source: 'drawer', rendered: !!rendered } }));
  }

  /* The cart page section, when it's on screen and not mid-edit. It rides along
     in the drawer's own mutation (`sections` takes a comma-separated list), so
     it never has to fetch a second render of the same cart. Mid-edit it is left
     alone — the debounced refresh path has its own qtyPending guard. */
  function cartSurface() {
    var el = document.querySelector('.ysl-cart[data-section-id]');
    var c = window.YSLCart;
    if (!el || !c || !c.applySection) return null;
    if (c.isBusy && c.isBusy()) return null;
    return { id: el.getAttribute('data-section-id'), apply: c.applySection };
  }

  /* Patch numbers in place when the structure is unchanged, else full render. */
  function applyHtml(html) { if (!html) return; if (!patch(html)) render(html); }

  /* Re-render the drawer from the server. The drawer lives in the theme LAYOUT,
     not a template — so a `?sections=` GET can't target it (it returns the full
     page, cacheable and stale). The cart AJAX API can: a no-op update.js
     (empty `updates`) returns the freshly rendered drawer section and is never
     full-page cached. Same render path change.js/add.js already use here. */
  function refresh(openAfter) {
    fetch(routesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data.sections && data.sections[SECTION_ID]) applyHtml(data.sections[SECTION_ID]); if (openAfter && !onCartPage()) open({ success: true }); })
      .catch(function () {});
  }

  /* Cross-surface sync: a mutation on the cart page (source 'cart') or a gwp
     gift scale (source 'gwp') only re-renders THAT surface — refresh the drawer
     in the background so it's current before the shopper opens it. Debounced;
     applyHtml patches in place, so an open drawer updates without a flash. */
  var xRefreshTimer = null;
  function scheduleDrawerRefresh() {
    if (qtyPending) return; /* shopper is mid-edit in the drawer — don't clobber the optimistic number */
    clearTimeout(xRefreshTimer);
    xRefreshTimer = setTimeout(function () { if (!qtyPending) refresh(false); }, 200);
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.rendered) return; /* the mutation already rendered us */
    var s = e.detail && e.detail.source;
    if (s === 'cart' || s === 'gwp') scheduleDrawerRefresh();
  });

  /* Identity of the drawer's structure. Same shape → the response differs only
     in numbers and can be patched in place; anything else needs a full render. */
  function shape(scope) {
    var keys = [];
    scope.querySelectorAll('[data-cart-item]').forEach(function (i) { keys.push(i.getAttribute('data-key')); });
    return (scope.querySelector('.ysl-cd__empty') ? 'E:' : '') + keys.join('|');
  }

  /* Write the new numbers into the DOM that is already on screen, instead of
     swapping the whole drawer. A full render() re-decodes every image, drops
     the body scroll position and blanks the recs row until the Recommendations
     API answers again — a whole-panel flash for what is only a price change.
     Returns false when the structure moved (a line gone, a gift added), so the
     caller can fall back to render(). */
  function patch(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-drawer]');
    var cur = root();
    if (!next || !cur) return false;
    if (shape(next) !== shape(cur)) return false;

    var nItems = next.querySelectorAll('[data-cart-item]');
    var cItems = cur.querySelectorAll('[data-cart-item]');
    for (var i = 0; i < cItems.length; i++) {
      var nTotal = nItems[i].querySelector('[data-line-total]');
      var cTotal = cItems[i].querySelector('[data-line-total]');
      if (nTotal && cTotal) cTotal.innerHTML = nTotal.innerHTML;

      /* Gift / gift-wrap lines have no stepper and no [data-line-total] — their
         quantity is printed in this span. Miss it and a gwp scale (4M → 1 gift,
         8M → 2) leaves the old number on screen while the cart really holds two. */
      var nFixed = nItems[i].querySelector('.ysl-cd__qty-fixed');
      var cFixed = cItems[i].querySelector('.ysl-cd__qty-fixed');
      if (nFixed && cFixed) cFixed.textContent = nFixed.textContent;

      /* server truth: a qty can come back clamped by stock */
      var nQty = nItems[i].querySelector('[data-qty-input]');
      var cQty = cItems[i].querySelector('[data-qty-input]');
      if (nQty && cQty && cQty.value !== nQty.value) cQty.value = nQty.value;
      /* carry the per-line stock cap (stock can move between renders) */
      var nMax = nItems[i].getAttribute('data-max-qty');
      if (nMax !== null) cItems[i].setAttribute('data-max-qty', nMax);

      /* per-line discount list (BXGY / % code) — a % code's amount moves with
         every qty edit, so sync it alongside the price */
      var nLd = nItems[i].querySelector('[data-line-discounts]');
      var cLd = cItems[i].querySelector('[data-line-discounts]');
      if (nLd && cLd) cLd.innerHTML = nLd.innerHTML;
    }

    var nShip = next.querySelector('.ysl-cd__ship');
    var cShip = cur.querySelector('.ysl-cd__ship');
    if (nShip && cShip) {
      /* the tier list is a <details> the shopper can collapse — keep their state */
      var open = cShip.querySelector('details');
      var wasOpen = open ? open.open : null;
      cShip.innerHTML = nShip.innerHTML;
      var again = wasOpen === null ? null : cShip.querySelector('details');
      if (again) again.open = wasOpen;
    }

    /* the "(N sản phẩm)" label sits in its own span — patch it too, or the
       money moves while the count stays on the previous number */
    var nCount = next.querySelector('[data-cd-count]');
    var cCount = cur.querySelector('[data-cd-count]');
    if (nCount && cCount) cCount.textContent = nCount.textContent;

    var nSub = next.querySelector('[data-cd-subtotal]');
    var cSub = cur.querySelector('[data-cd-subtotal]');
    if (nSub && cSub) cSub.textContent = nSub.textContent;

    /* same rule as the cart page: a % code's amount moves with every qty edit */
    var nDisc = next.querySelector('[data-cd-discounts]');
    var cDisc = cur.querySelector('[data-cd-discounts]');
    if (nDisc && cDisc) cDisc.innerHTML = nDisc.innerHTML;

    var rc = parseInt(next.getAttribute('data-cart-count'), 10);
    if (!isNaN(rc)) { cur.setAttribute('data-cart-count', rc); mirrorHeaderCount(rc); }

    clearBusy();
    setLoading(false);
    capAll();
    enforceCaps();
    document.dispatchEvent(new CustomEvent('ysl:cart-changed'));
    atcSyncAll();
    return true;
  }

  function clearBusy() {
    var r = root();
    if (r) r.querySelectorAll('[data-line-total].is-busy').forEach(function (el) { el.classList.remove('is-busy'); });
  }

  /* The cart as it will be AFTER this change, read off the DOM the last
     authoritative response rendered. gwp plans off this instead of spending a
     cart.js read of its own, which is what lets the gift adjustment ride along
     in the same request. Shaped like /cart.js so plan() needs no special case. */
  function predictCart(root, changedKey, newQty) {
    var items = [];
    var total = 0;
    root.querySelectorAll('[data-cart-item]').forEach(function (li) {
      var key = li.getAttribute('data-key');
      var unit = parseInt(li.getAttribute('data-unit'), 10) || 0;
      var qty;
      if (key === changedKey) {
        qty = newQty;
      } else {
        var inp = li.querySelector('[data-qty-input]');
        if (inp) {
          qty = parseInt(inp.value, 10) || 0;
        } else {
          /* gift / gift-wrap lines print their quantity instead of a stepper */
          var fixed = li.querySelector('.ysl-cd__qty-fixed');
          var m = fixed && fixed.textContent.match(/\d+/);
          qty = m ? parseInt(m[0], 10) : 1;
        }
      }
      var gwp = li.getAttribute('data-gwp');
      items.push({
        key: key,
        variant_id: li.getAttribute('data-variant-id'),
        product_id: li.getAttribute('data-product-id'),
        quantity: qty,
        final_line_price: unit * qty,
        properties: gwp ? { _gwp: gwp } : {}
      });
      total += unit * qty;
    });
    /* net of the order (cart-level) discount — same as ysl-gwp.js domCart */
    total -= parseInt(root.getAttribute('data-gwp-discount'), 10) || 0;
    if (total < 0) total = 0;
    return { total_price: total, items: items };
  }

  /* @param key - the STABLE line-item key, NOT a positional line number. gwp
     adds/removes gift lines on the first add, which re-renders the drawer and
     renumbers every line; a debounced tap that captured the old number would
     then hit the wrong line (the bug where a qty bumped to 5 snapped back). A
     key always resolves to the same item; if it has since been removed the
     request fails and the drawer re-renders — never a wrong-line write. */
  function changeLine(key, quantity, soft) {
    var r = root();
    var el = key && r && r.querySelector('[data-cart-item][data-key="' + key + '"]');
    if (!el) return; /* line already gone (re-rendered away) — nothing to do */
    var busy = el.querySelector('[data-line-total]');
    if (busy) busy.classList.add('is-busy');
    if (!soft) setLoading(true);

    /* Fold gwp's gift adjustment into this same key-addressed update.js (gwp's
       listener still verifies after, so a mispredicted fold self-heals). */
    var updates = {};
    if (window.YSLGwp && window.YSLGwp.fold) {
      try { var gift = window.YSLGwp.fold(predictCart(r, key, quantity)); if (gift) updates = gift; } catch (err) { updates = {}; }
    }
    updates[key] = quantity;

    var page = cartSurface();
    var secList = page ? SECTION_ID + ',' + page.id : SECTION_ID;
    /* One line → change.js, several (a gift folded in) → update.js. Shopify's
       web pixel reports a decrease as remove_from_cart ONLY for change.js; an
       update.js decrease reports nothing, so every drawer remove/step-down used
       to be missing from GA4 while step-ups were counted (measured 10/2026).
       ysl-gwp.js no longer folds, so in practice this is always change.js. */
    var single = Object.keys(updates).length === 1;
    var body = single
      ? { id: key, quantity: quantity, sections: secList, sections_url: window.location.pathname }
      : { updates: updates, sections: secList, sections_url: window.location.pathname };

    fetch(routesRoot() + (single ? 'cart/change.js' : 'cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r2) { return r2.json().then(function (b) { return { ok: r2.ok, body: b }; }); })
      .then(function (res) {
        /* change.js answers a key that no longer exists with a 400, where
           update.js silently did nothing — re-render from the real cart. */
        if (!res.ok) { refresh(false); return; }
        var state = res.body;
        var pHtml = page && state.sections && state.sections[page.id];
        if (pHtml) page.apply(pHtml);
        updateHeader(realCount(state), !!pHtml);
        var html = state.sections && state.sections[SECTION_ID];
        if (html) { if (!patch(html)) render(html); } else refresh(false);
      })
      .catch(function () { clearBusy(); setLoading(false); });
  }

  /* Shared success path for any add: render the drawer from the add.js
     response, read the count off the rendered root, run GWP in the background. */
  function handleAddResult(res) {
    var html = res.body.sections && res.body.sections[SECTION_ID];
    if (html) {
      render(html);
      if (!onCartPage()) open({ success: true });
      /* item_count comes off the freshly-rendered drawer root — no cart.js. */
      var r = root();
      var count = r && parseInt(r.getAttribute('data-cart-count'), 10);
      if (!isNaN(count)) updateHeader(count);
    } else {
      refresh(true);
    }
    /* Gift-with-purchase (if any rule is active) reconciles in the background
       and re-renders only when it actually changes the cart. */
    if (window.YSLGwp) {
      /* strictly true = gwp changed the cart but could not render this surface
         itself; 'applied' means it already did. */
      window.YSLGwp.sync().then(function (changed) { if (changed === true) refresh(false); });
    }
  }

  /* Feedback on the add-to-cart control itself: the button swaps to a spinner
     while /cart/add.js is in flight, then a tick + "Đã thêm vào giỏ".
     Source of truth for the tick = THE RENDERED CART ITSELF: the drawer root
     lives in the theme LAYOUT on every page and renders server-side from the
     real cart, so "tick ⇔ this variant is a line in the cart right now" is a
     DOM lookup — no separate store to go stale on variant switches, removals
     or reloads. */
  var ATC_ADDED_HTML = '<svg class="ysl-atc-tick" viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M2.5 8.5L6.5 12.5L13.5 4.5" stroke="currentColor" stroke-width="2"/></svg><span>' + T('cartAdded', 'Đã thêm vào giỏ') + '</span>';
  function atcInCart(vid) {
    if (!vid) return false;
    var rootEl = document.querySelector('[data-cart-drawer]');
    if (!rootEl) return false;
    return !!rootEl.querySelector('[data-cart-item][data-variant-id="' + vid + '"]');
  }
  /* Snapshot the button's NORMAL markup exactly once, and only while it is
     actually displaying that normal markup — this is the only safe restore
     target for reset(). */
  function atcSnap(btn) {
    if (btn._atcHtml == null && !btn.classList.contains('is-atc-added') && !btn.classList.contains('is-atc-busy')) {
      btn._atcHtml = btn.innerHTML;
    }
  }
  function atcBusy(btn) {
    if (!btn || btn._atcState === 'busy') return;
    btn._atcState = 'busy';
    atcSnap(btn);
    btn.classList.add('is-atc-busy');
    btn.disabled = true;
    btn.innerHTML = '<span class="ysl-atc-spin" aria-hidden="true"></span>';
  }
  function atcAdded(btn) {
    if (!btn || btn._atcState !== 'busy') return; /* only right after our own busy() */
    btn._atcState = 'added';
    btn.classList.remove('is-atc-busy');
    btn.classList.add('is-atc-added');
    btn.innerHTML = ATC_ADDED_HTML;
  }
  function atcReset(btn) {
    if (!btn) return;
    btn._atcState = null;
    if (btn._atcHtml != null) btn.innerHTML = btn._atcHtml;
    btn.classList.remove('is-atc-busy', 'is-atc-added');
    btn.disabled = false;
  }
  /* Paint the right state for a variant onto an ATC button: reset first, then
     re-apply the tick only if THIS variant is currently in the cart.
     Public via YSLCartDrawer.syncAtc so the PDP can drive it on load + on
     every variant switch. */
  function atcSync(btn, vid) {
    if (!btn || btn._atcState === 'busy') return; /* never clobber an in-flight spinner */
    atcSnap(btn);
    atcReset(btn);
    if (atcInCart(vid)) {
      btn._atcState = 'added';
      btn.classList.add('is-atc-added');
      btn.innerHTML = ATC_ADDED_HTML;
    }
  }
  /* Sync EVERY add-to-cart button on the page with the current cart: product
     cards (PLP/search/related/recommendations/FBT), the hotspot popup, the
     PDP form and the drawer's own variant buttons. Tick while its variant is
     a cart line, plain markup otherwise. */
  function atcSyncAll() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (f) {
      var idEl = f.querySelector('[name="id"]');
      var btn = f.querySelector('[type="submit"]');
      if (idEl && btn) atcSync(btn, idEl.value);
    });
    document.querySelectorAll('[data-cdr-add]').forEach(function (b) {
      atcSync(b, b.getAttribute('data-variant'));
    });
  }

  function addToCart(form, submitter) {
    var fd = new FormData(form);
    /* Ask /cart/add.js to render the drawer section in the SAME response, so a
       normal add is ONE round trip (was three: add → cart.js → ?sections). */
    fd.append('sections', SECTION_ID);
    fd.append('sections_url', window.location.pathname);
    var btn = submitter || form.querySelector('[type="submit"]');
    /* Optimistic: slide the drawer in NOW with a spinner, before the request
       resolves, so the click feels instant. render() clears is-pending when
       the real content lands. */
    if (!onCartPage()) open({ success: true, pending: true });
    setLoading(true);
    atcBusy(btn);
    fetch(routesRoot() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { atcReset(btn); form.submit(); return; }
        atcAdded(btn);
        handleAddResult(res);
      })
      .catch(function () { atcReset(btn); form.submit(); });
  }

  /* Add a single variant (used by the "Thêm vào giỏ" button on recommendation
     cards). Same optimistic-open + one-round-trip flow as addToCart. */
  function addVariant(variantId, btn) {
    if (!onCartPage()) open({ success: true, pending: true });
    setLoading(true);
    atcBusy(btn);
    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { atcReset(btn); refresh(true); return; }
        atcAdded(btn);
        handleAddResult(res);
      })
      .catch(function () { atcReset(btn); setLoading(false); });
  }

  /* --- number pad: DISABLED ---
     Manual quantity entry was removed (both the desktop typed field and the
     touch number-pad) — quantity changes only through the +/− stepper. The pad
     markup is gone from the Liquid and the input is readonly, so TOUCH is forced
     false: armPad()/padOpen() become no-ops and no pad ever opens. The pad
     functions below are kept (null-safe, dead) to keep this diff small. */
  var TOUCH = false;
  var PAD_MAX = 99;
  /* Hard per-item quantity cap (mirrors ysl-cart.js). Over it → clamp + toast.
     PAD_MAX stays the pad's typing-buffer length; MAX_QTY is the real ceiling. */
  var MAX_QTY = 5;
  /* Per-line cap: the global 5, OR the variant's remaining stock when lower
     (Liquid writes data-max-qty). Never below what's already in the line. */
  function rawCap(item) {
    var m = parseInt(item && item.getAttribute('data-max-qty'), 10);
    return isNaN(m) ? MAX_QTY : m;
  }
  /* Stepper ceiling: never below the current qty so a + can't reduce an over-cap
     line — enforceCaps() pulls that back down instead. */
  function maxFor(item) {
    var input = item && item.querySelector('[data-qty-input]');
    var cur = input ? (parseInt(input.value, 10) || 0) : 0;
    return Math.max(rawCap(item), cur);
  }
  function capMsg(item) {
    var m = parseInt(item && item.getAttribute('data-max-qty'), 10);
    if (isNaN(m)) m = MAX_QTY;
    if (m < MAX_QTY) return T('cartMaxLow', 'Sản phẩm sắp hết hàng — đã đạt số lượng tối đa có thể mua.');
    return T('cartMaxDefault', 'Tối đa %n% sản phẩm mỗi loại — cần nhiều hơn vui lòng liên hệ hotline.').replace('%n%', m);
  }
  /* Grey the + (and − at min) at the bound; the + still fires clicks so a tap at
     the cap shows the toast — hence a class, not the disabled attribute. */
  function capState(item) {
    if (!item) return;
    var input = item.querySelector('[data-qty-input]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 0;
    var max = maxFor(item);
    var inc = item.querySelector('[data-step="1"]');
    var dec = item.querySelector('[data-step="-1"]');
    if (inc) inc.classList.toggle('is-maxed', v >= max);
    /* drawer floors at 1: the − is disabled there — removal is via the trash icon */
    if (dec) dec.classList.toggle('is-maxed', v <= 1);
  }
  function capAll() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('[data-cart-item]:not([data-gwp]):not([data-giftwrap])').forEach(capState);
    /* server HTML renders gift lines hidden by default — reveal the earned ones */
    if (window.YSLGwp && window.YSLGwp.paint) { try { window.YSLGwp.paint(); } catch (err) {} }
  }
  /* Safety net: /cart/add.js takes any quantity, and the same variant can sit on
     several lines (differing properties), so the cap is per VARIANT-TOTAL, not
     per line — sum a variant's non-freebie lines and trim the excess from the
     last lines first. Key-addressed update.js. On /cart the cart page owns this
     (its update carries the drawer section), so bail there to avoid a double
     write. Idempotent — no-op once every variant sits at its cap. */
  function enforceCaps() {
    if (document.querySelector('.ysl-cart[data-section-id]')) return;
    var r = root();
    if (!r) return;
    var els = [].slice.call(r.querySelectorAll('[data-cart-item]'));
    function lineQty(el) {
      var inp = el.querySelector('[data-qty-input]');
      if (inp) return parseInt(inp.value, 10) || 0;
      var f = el.querySelector('.ysl-cd__qty-fixed');
      var m = f && f.textContent.match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 0;
    }
    var orig = els.map(lineQty), next = orig.slice();
    /* Group by variant + PUBLIC properties (see ysl-cart.js): a private `_` prop
       difference is the same item (shared cap), but a different engraving is a
       distinct gift the cap must not merge away. */
    function groupKey(el) {
      var dl = el.querySelector('.ysl-cd__props');
      return el.getAttribute('data-variant-id') + '|' + (dl ? dl.textContent.replace(/\s+/g, ' ').trim() : '');
    }
    var byVar = {};
    els.forEach(function (el, i) {
      if (el.getAttribute('data-gwp') || el.getAttribute('data-giftwrap')) return;
      var g = groupKey(el);
      (byVar[g] = byVar[g] || []).push(i);
    });
    var toastItem = null;
    Object.keys(byVar).forEach(function (v) {
      var idxs = byVar[v], cap = rawCap(els[idxs[0]]);
      var excess = idxs.reduce(function (s, i) { return s + next[i]; }, 0) - cap;
      for (var k = idxs.length - 1; k >= 0 && excess > 0; k--) {
        var i = idxs[k], take = Math.min(excess, next[i]);
        next[i] -= take; excess -= take; toastItem = els[idxs[0]];
      }
    });
    var updates = {};
    els.forEach(function (el, i) {
      if (next[i] === orig[i]) return;
      updates[el.getAttribute('data-key')] = next[i];
      var inp = el.querySelector('[data-qty-input]');
      if (inp) { inp.value = next[i]; capState(el); }
    });
    if (!Object.keys(updates).length) return;
    fetch(routesRoot() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTION_ID, sections_url: window.location.pathname })
    })
      .then(function (r2) { return r2.json(); })
      .then(function (state) {
        var html = state.sections && state.sections[SECTION_ID];
        if (html) applyHtml(html);
        updateHeader(realCount(state));
      })
      .catch(function () {});
    if (toastItem) qtyToast(capMsg(toastItem));
  }
  function qtyToast(msg) {
    var t = document.getElementById('ysl-toast');
    if (!t) { t = document.createElement('div'); t.id = 'ysl-toast'; t.className = 'ysl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg || T('cartMaxDefault', 'Tối đa %n% sản phẩm mỗi loại — cần nhiều hơn vui lòng liên hệ hotline.').replace('%n%', MAX_QTY);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  /* Debounce the server write on stepper taps (Vinamilk-style): the number moves
     on every tap, but changeLine fires ONCE ~400ms after the last tap with the
     final quantity — rapid +/- feels instant and doesn't re-render the drawer on
     every click. A tap on a different line flushes the pending write first. */
  var qtyTimer = null, qtyPending = null;
  function flushQty() {
    if (!qtyPending) return;
    var q = qtyPending; qtyPending = null;
    /* soft: the number already moved on tap, so don't pointer-lock the panel
       while this write reconciles — the +/- buttons must stay live. Keyed, not
       positional: a gwp re-render between the tap and this flush would otherwise
       point the write at the wrong line. */
    changeLine(q.key, q.qty, true);
  }
  function scheduleChange(key, qty) {
    if (qtyPending && qtyPending.key !== key) flushQty();
    qtyPending = { key: key, qty: qty };
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQty, 400);
  }

  var pad = { line: 0, was: 0, val: '' };

  function padEl() { var r = root(); return r && r.querySelector('[data-cd-pad]'); }
  function padIsOpen() { var p = padEl(); return !!(p && !p.hidden); }

  /* Runs on every render — the drawer root (and its inputs) is replaced. */
  function armPad() {
    if (!TOUCH) return;
    var r = root();
    if (!r) return;
    r.classList.add('ysl-cd--pad');
    r.querySelectorAll('[data-cart-item] [data-qty-input]').forEach(function (i) {
      if (!i.hasAttribute('readonly')) i.readOnly = true;
    });
  }

  function padPaint() {
    var p = padEl();
    if (!p) return;
    p.querySelector('[data-cd-pad-val]').textContent = pad.val === '' ? String(pad.was) : pad.val;
  }

  function padOpen(item) {
    var p = padEl();
    var input = item.querySelector('[data-qty-input]');
    if (!p || !input) return;
    var name = item.querySelector('.ysl-cd__name');
    pad.line = parseInt(item.getAttribute('data-line'), 10);
    pad.was = Math.max(0, parseInt(input.value, 10) || 0);
    pad.val = '';
    p.querySelector('[data-cd-pad-name]').textContent = name ? name.textContent.trim() : '';
    padPaint();
    p.hidden = false;
  }

  function padClose() { var p = padEl(); if (p) p.hidden = true; }

  function padCommit() {
    var raw = pad.val === '' ? pad.was : (parseInt(pad.val, 10) || 0);
    var line = pad.line;
    var item = line && root() && root().querySelector('[data-cart-item][data-line="' + line + '"]');
    var lineMax = maxFor(item);
    if (raw < 1) raw = 1; /* floor 1 — remove via trash, not by typing 0 */
    var capped = raw > lineMax;
    var qty = capped ? lineMax : raw;
    padClose();
    if (capped) qtyToast(capMsg(item));
    if (qty === pad.was || !line) return;
    var input = item && item.querySelector('[data-qty-input]');
    if (input) input.value = qty;
    if (item) capState(item);
    changeLine(item.getAttribute('data-key'), qty);
  }

  /* Returns true when the click belonged to the pad (or opened it). */
  function padClick(e) {
    if (e.target.closest('[data-cd-pad-cancel]')) { padClose(); return true; }
    if (e.target.closest('[data-cd-pad-ok]')) { padCommit(); return true; }
    if (e.target.closest('[data-cd-pad-back]')) { pad.val = pad.val.slice(0, -1); padPaint(); return true; }
    /* Clear means "0" (confirming it removes the line), not "back to what it
       was" — pad.was must stay the original so padCommit can spot a no-op. */
    if (e.target.closest('[data-cd-pad-clear]')) { pad.val = '0'; padPaint(); return true; }
    var key = e.target.closest('[data-cd-pad-key]');
    if (key) {
      var next = (pad.val + key.getAttribute('data-cd-pad-key')).replace(/^0+(?=\d)/, '');
      if (next.length <= String(PAD_MAX).length) pad.val = next;
      padPaint();
      return true;
    }
    if (!TOUCH) return false;
    var field = e.target.closest('[data-cart-drawer] [data-cart-item] [data-qty-input]');
    if (field && !field.closest('.ysl-cd__stepper--locked')) {
      e.preventDefault();
      field.blur();
      padOpen(field.closest('[data-cart-item]'));
      return true;
    }
    return false;
  }

  /* --- delegated events --- */

  /* Where the current gesture STARTED. A tap that begins on one element and
     ends on a closer (the overlay) must not close the drawer: on a phone that
     happens when the soft keyboard is dismissed, or when the panel re-renders
     under a resting finger. Null when no pointer info (synthetic .click()). */
  var downTarget = null;
  document.addEventListener('pointerdown', function (e) { downTarget = e.target; }, true);

  document.addEventListener('click', function (e) {
    var down = downTarget;
    downTarget = null;

    var cartLink = e.target.closest('.ysl-head__cart, .ysl-mdr__cart, [data-ysl-cart-open]');
    if (cartLink && root() && !onCartPage()) { e.preventDefault(); open(); return; }

    var recAdd = e.target.closest('[data-cdr-add]');
    if (recAdd) { e.preventDefault(); addVariant(recAdd.getAttribute('data-variant'), recAdd); return; }

    if (padClick(e)) return;

    var closer = e.target.closest('[data-cd-close]');
    if (closer) {
      /* a real link (e.g. a recommendation card) closes by navigating away —
         let the browser follow it; only non-link closers (the X, "keep
         shopping") preventDefault + close in place. */
      var a = closer.tagName === 'A' ? closer : closer.closest('a[href]');
      if (a && a.getAttribute('href') && a.getAttribute('href').charAt(0) !== '#') return;
      if (down && !closer.contains(down)) return;
      e.preventDefault(); close(); return;
    }

    var step = e.target.closest('[data-cart-drawer] [data-step]');
    if (step) {
      var item = step.closest('[data-cart-item]');
      var input = item.querySelector('[data-qty-input]');
      var prev = parseInt(input.value, 10) || 0;
      var lineMax = maxFor(item);
      var next = prev + parseInt(step.getAttribute('data-step'), 10);
      var capped = false;
      if (next > lineMax) { next = lineMax; capped = true; }
      if (next < 1) next = 1; /* floor 1 — the − can't empty the line; use the trash icon */
      if (next === prev) { if (capped) qtyToast(capMsg(item)); return; }
      input.value = next;
      capState(item);
      if (window.YSLGwp && window.YSLGwp.paint) { try { window.YSLGwp.paint(); } catch (err) {} }
      scheduleChange(item.getAttribute('data-key'), next);
      if (capped) qtyToast(capMsg(item));
      return;
    }
    var remove = e.target.closest('[data-cart-drawer] [data-remove]');
    if (remove) {
      e.preventDefault();
      var ri = remove.closest('[data-cart-item]');
      changeLine(ri.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-drawer] [data-qty-input]');
    if (!input) return;
    var item = input.closest('[data-cart-item]');
    var lineMax = maxFor(item);
    var qty = Math.max(1, parseInt(input.value, 10) || 1); /* floor 1 — remove via trash */
    var capped = qty > lineMax;
    if (capped) qty = lineMax;
    input.value = qty;
    capState(item);
    changeLine(item.getAttribute('data-key'), qty);
    if (capped) qtyToast(capMsg(item));
  });

  /* Window + capture + stopImmediatePropagation, not a plain document listener:
     Shopify's web-pixel manager counts a submit of a /cart/add form as
     product_added_to_cart AND counts the AJAX /cart/add.js below as another
     one, so every PDP add reached GA4 as two add_to_cart (measured 10/2026:
     one POST, events at +26ms and +1351ms). Swallowing the submit here leaves
     only the AJAX one. */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action$="/cart/add"]') && root()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(form, e.submitter);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (padIsOpen()) { padClose(); return; }
    close();
  });

  armPad();
  capAll();
  enforceCaps();
  atcSyncAll();

  /* Public hook so ysl-gwp.js can re-render after it adds/removes a gift line.
     `render` lets gwp hand over the HTML its own mutation already carried, so
     the drawer never has to fetch a second render of the same cart. */
  window.YSLCartDrawer = {
    refresh: refresh,
    applySection: applyHtml,
    open: open,
    close: close,
    isBusy: function () { return !!qtyPending; },
    resetAtc: atcReset,
    syncAtc: atcSync,
    syncCards: atcSyncAll,
    isAdded: atcInCart
  };
  /* deferred load order varies per page — let ATC owners re-sync their button
     against the added-variants store once this driver exists */
  document.dispatchEvent(new CustomEvent('ysl:cart-ready'));
})();
